import Mgr from '@/services/SecurityService'

const mgr = new Mgr()

export const state = {
  roles: null
}

export const getters = {
  isAuthorizedUser: state => {
    return state.roles && state.roles.includes('WGUser')
  },
  roles: state => {
    return state.roles
  }
}

export const mutations = {
  SET_ROLES (state, data) {
    state.roles = data
  }
}

export const actions = {
  setRoles ({ commit }) {
    mgr.getRole().then(roles => {
      commit('SET_ROLES', roles)
    })
  }
}
